function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNounHistory = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 200 200",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M44.598 37.977c-2.47-2.391-6.43-2.336-8.84.128a88.4 88.4 0 0 0-19.254 29.747c-1.258 3.203.336 6.808 3.555 8.058 3.222 1.246 6.851-.344 8.109-3.543a76.2 76.2 0 0 1 16.574-25.594 6.203 6.203 0 0 0-.144-8.796m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "currentcolor",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M100 189.191c36.32.012 69.055-21.773 82.879-55.152 13.82-33.383 5.996-71.754-19.809-97.152C137.258 11.484 98.574 4.094 65.125 18.16a6.2 6.2 0 0 0-2.902 7.957c1.28 2.992 4.675 4.504 7.777 3.45 31.328-13.165 67.633-4.368 89.352 21.644 21.718 26.016 23.718 63.102 4.925 91.27-18.789 28.18-53.941 40.785-86.5 31.035-32.566-9.754-54.855-39.559-54.863-73.36 0-3.433-2.793-6.215-6.25-6.215-3.45 0-6.25 2.782-6.25 6.215.063 49.145 40.133 88.973 89.586 89.035m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "currentcolor",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M100 166.41c36.82 0 66.664-29.66 66.664-66.254 0-36.597-29.844-66.258-66.664-66.258s-66.664 29.66-66.664 66.258c0 36.594 29.844 66.254 66.664 66.254M93.75 58.742c0-3.43 2.8-6.21 6.25-6.21s6.25 2.78 6.25 6.21v38.262l30.836 23.031a6.19 6.19 0 0 1 1.25 8.692 6.274 6.274 0 0 1-8.75 1.238L96.25 105.12a6.11 6.11 0 0 1-2.5-4.965Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "currentcolor",
    fillOpacity: 1
  }
}));
export { SvgNounHistory as ReactComponent };
export default __webpack_public_path__ + "assets/images/noun-history.svg";